/**
 * Utilidades para desofuscar datos del backend
 */

const DataObfuscator = {
    // Mapeo de campos ofuscados a originales
    keyMapping: {
        // Prestador
        'uid': 'id',
        'lbl': 'nombre',
        'front': 'url_front',
        'attrs': 'atributos',
        'adm': 'admin',
        
        // Listas generales
        'ins': 'aseguradoras',
        'reg': 'regiones',
        'cat': 'categorias',
        'com': 'comunas',
        'exam': 'examenes',
        'disc': 'descuentos',
        
        // Campos específicos
        'cs': 'costo_servicio',
        'csp': 'costo_servicio_pendiente',
        'csa': 'costo_servicio_asegurador',
        'csc': 'costo_servicio_comuna',
        'pepcc': 'precios_examen_prestador_categoria_cliente',
        'cscc': 'costo_servicio_categoria_cliente',
        'dcsac': 'descuento_costo_servicio_asegurador_comuna',
        'cat_u': 'categorias_usadas',
        'com_u': 'comunas_usadas',
        
        // Campos de objetos
        'act': 'activo',
        'ayu': 'ayuno',
        'pr': 'precio',
        'kw': 'keywords',
        'info': 'informacion',
        'des': 'desde',
        'has': 'hasta',
        'lnk': 'link',
        'cod': 'codigo',
        'cod_i': 'codigo_int',
        'ep_id': 'examen_prestador_id',
        'req_o': 'requiere_orden',
        'req_p': 'requiere_pago',
        'cat_id': 'categoria_id',
        'pr_com': 'precios_por_comuna',
        'val': 'valor',
        'exam_id': 'examen_id',
        'aseg_id': 'aseguradora_id',
        'lat': 'lat',
        'lon': 'lon',
        'reg_id': 'region',
        'reg_k': 'region_id',  // <-- AÑADIDO
        'n': 'Nombre',         // <-- AÑADIDO
        'cfg': 'config',
        'ast': 'assets',
        'col': 'colors',
        'nav': 'navigation',
        'pri': 'primary',
        'sec': 'secondary',
        'Nombre': 'Nombre',
        'id': 'id'
    },

    /**
     * Decodifica un ID desde base64
     */
    decodeId(encoded) {
        if (!encoded) return null;
        try {
            // Añadir padding si es necesario
            let str = encoded;
            while (str.length % 4) {
                str += '=';
            }
            const decoded = atob(str);
            const num = parseInt(decoded, 10);
            return isNaN(num) ? decoded : num;
        } catch (error) {
            console.warn('Error decoding ID:', encoded, error);
            return encoded;
        }
    },

    /**
     * Codifica un ID a base64
     */
    encodeId(value) {
        if (value === null || value === undefined) return null;
        return btoa(String(value)).replace(/=+$/, '');
    },

    /**
     * Desofusca una estructura completa de datos
     */
    deobfuscate(data) {
        if (Array.isArray(data)) {
            return data.map(item => this.deobfuscate(item));
        } else if (data && typeof data === 'object') {
            const result = {};
            
            for (const [key, value] of Object.entries(data)) {
                // Saltar campos de metadatos
                if (key.startsWith('_')) {
                    result[key] = value;
                    continue;
                }
                
                // Obtener el nombre original del campo
                const originalKey = this.keyMapping[key] || key;
                
                // Procesar el valor
                if (value && typeof value === 'object') {
                    result[originalKey] = this.deobfuscate(value);
                } else if (
                    // Lista de campos que contienen IDs codificados
                    ['uid', 'k', 'id', 'exam_id', 'aseg_id', 'cat_id', 'reg_id', 
                     'examen_id', 'aseguradora_id', 'categoria_id', 'region', 
                     'reg_k'].includes(key) &&  // <-- AÑADIDO reg_k
                    typeof value === 'string'
                ) {
                    // Decodificar IDs
                    result[originalKey] = this.decodeId(value);
                } else {
                    result[originalKey] = value;
                }
            }
            
            return result;
        }
        return data;
    },

    /**
     * Ofusca una estructura de datos (para debugging)
     */
    obfuscate(data) {
        if (Array.isArray(data)) {
            return data.map(item => this.obfuscate(item));
        } else if (data && typeof data === 'object') {
            const result = {};
            const reverseMapping = {};
            
            // Crear mapeo inverso
            for (const [original, obfuscated] of Object.entries(this.keyMapping)) {
                reverseMapping[obfuscated] = original;
            }
            
            for (const [key, value] of Object.entries(data)) {
                const obfuscatedKey = reverseMapping[key] || key;
                
                if (value && typeof value === 'object') {
                    result[obfuscatedKey] = this.obfuscate(value);
                } else if (
                    ['id', 'examen_id', 'aseguradora_id', 'categoria_id', 
                     'region', 'region_id'].includes(key) &&  // <-- AÑADIDO region_id
                    (typeof value === 'number' || typeof value === 'string')
                ) {
                    // Codificar IDs
                    result[obfuscatedKey] = this.encodeId(value);
                } else {
                    result[obfuscatedKey] = value;
                }
            }
            
            return result;
        }
        return data;
    }
};

export default DataObfuscator;